import { META } from './data';

export default function Footer({ setPage }) {
  return (
    <footer className="bg-[#0A0E14] text-[#E6EDF3] border-t border-[#1A2230] mt-24">
      <div className="max-w-[1500px] mx-auto px-5 lg:px-8 py-14 grid md:grid-cols-[1.5fr_1fr_1fr_1fr] gap-10 font-mono text-sm">
        <div>
          <p className="text-2xl text-[#E6EDF3] lowercase">{META.brand}</p>
          <p className="text-[10px] text-[#5F7184] mt-1">{META.tag}</p>
          <p className="text-xs text-[#5F7184] mt-5 leading-[1.7] max-w-md font-sans">A live-ops platform for engineering teams running production at scale. Run code, queue jobs, store secrets, observe everything — in 18 regions, under one panel.</p>
          <div className="mt-6 flex items-center gap-2 text-[10px] text-[#5F7184]">
            <span className="inline-block w-1.5 h-1.5 rounded-full bg-[#06D6A0] animate-pulse"></span>
            <span>all systems normal · uptime 99.992%</span>
          </div>
        </div>
        <div>
          <p className="text-[10px] uppercase tracking-[0.32em] text-[#5F7184] mb-3">platform</p>
          <ul className="space-y-2 text-xs text-[#E6EDF3]/85">
            <li><button onClick={() => setPage('modules')} className="hover:text-[#06D6A0]">edge runtime</button></li>
            <li><button onClick={() => setPage('modules')} className="hover:text-[#06D6A0]">job queue</button></li>
            <li><button onClick={() => setPage('modules')} className="hover:text-[#06D6A0]">vault</button></li>
            <li><button onClick={() => setPage('modules')} className="hover:text-[#06D6A0]">observability</button></li>
          </ul>
        </div>
        <div>
          <p className="text-[10px] uppercase tracking-[0.32em] text-[#5F7184] mb-3">resources</p>
          <ul className="space-y-2 text-xs text-[#E6EDF3]/85">
            <li><button onClick={() => setPage('status')} className="hover:text-[#06D6A0]">status page</button></li>
            <li><a href="#" className="hover:text-[#06D6A0]">api reference</a></li>
            <li><a href="#" className="hover:text-[#06D6A0]">cli docs</a></li>
            <li><a href="#" className="hover:text-[#06D6A0]">changelog</a></li>
          </ul>
        </div>
        <div>
          <p className="text-[10px] uppercase tracking-[0.32em] text-[#5F7184] mb-3">company</p>
          <ul className="space-y-2 text-xs text-[#E6EDF3]/85">
            <li><button onClick={() => setPage('pricing')} className="hover:text-[#06D6A0]">pricing</button></li>
            <li><a href="#" className="hover:text-[#06D6A0]">trust & security</a></li>
            <li><a href="#" className="hover:text-[#06D6A0]">careers · 14 open</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#1A2230] px-5 lg:px-8 py-4 max-w-[1500px] mx-auto flex flex-wrap items-center justify-between gap-4 font-mono text-[10px] text-[#5F7184]">
        <span>© 2026 {META.brand} engineering · est. {META.est} · soc2 · hipaa · fedramp</span>
        <span>// built in San Francisco · Berlin · Singapore</span>
      </div>
    </footer>
  );
}
